class AssetExportForWpp {
  exportDate = '';  
  
  source = '';  
  
  sourceSite = '';  
  
  docId = '';  
  
  assetUrl = '';  
  
  title = '';  
  
  description = '';  
  
  contentType = '';  
  
  publishedDate = '';  
  
  assetVisibility = '';  
  
  topics = '';  
  
  keywords = '';  
  
  keyContacts = '';  
  
  agencies = '';  
  
  capabilities = '';  
  
  clients = '';  
  
  brands = '';  
  
  campaign = '';  
  
  subIndustries = '';  
  
  region = '';  
  
  country = '';  
  
  usageGuideLines = '';  
  
  content = '';

  constructor(data) {
    if (data == null) {
      return;
    }

    this.exportDate = data.exportDate;
    this.source = data.source;
    this.sourceSite = data.sourceSite;
    this.docId = data.docId;
    this.assetUrl = data.assetUrl;
    this.title = data.title;
    this.description = data.description;
    this.contentType = data.contentType;
    this.publishedDate = data.publishedDate;
    this.assetVisibility = data.assetVisibility;
    this.topics = data.topics;
    this.keywords = data.keywords;
    this.keyContacts = data.keyContacts;
    this.agencies = data.agencies;
    this.capabilities = data.capabilities;
    this.clients = data.clients;
    this.brands = data.brands;
    this.campaign = data.campaign;
    this.subIndustries = data.subIndustries;
    this.region = data.region;
    this.country = data.country;
    this.usageGuideLines = data.usageGuideLines;
    this.content = data.content;
  }

  static fromObject(data) {
    if (data == null) {
      return null;
    }

    return new AssetExportForWpp(data);
  }

  static fromObjects(list) {
    if (list == null) {
      return null;
    }

    return list.map((data) => this.fromObject(data));
  }
}

export default AssetExportForWpp;
